import { tv } from '~/utils/tv'

export const ContentSubtitleVariants = tv({
  base: `
    text-text-neutral-alternative !font-rdmodern font-regular leading-medium
    line-clamp-2 text-start overflow-ellipsis
  `,
  variants: {
    size: {
      tiny: 'text-threepulse',
      xs: 'text-threeandhalfpulse',
    },
  },
})
